export default "__VITE_ASSET__06eaf49a__"